import Modal from "./modal";
import Chat from "../components/chat";
import FormConsulting from "../forms/consulting";

export default {
	name: 'InterestBar',
	components: {
		Chat,
		Modal,
		FormConsulting,
	},
	data() {
		return {
			openConsulting: false,
		};
	},
}
